import { err, ok, type Result } from '../../../core/result';
import { parseCitizens, type CitizenAsset } from './citizenAsset';

/** Fetches and reads the citizens' file; an error says what went wrong, for the visitor to read. */
export async function loadCitizens(
  url: string,
  fetchImpl: typeof fetch = fetch
): Promise<Result<CitizenAsset, string>> {
  let buffer: ArrayBuffer;
  try {
    const response = await fetchImpl(url);
    if (!response.ok) return err(`HTTP ${String(response.status)} fetching ${url}`);
    buffer = await response.arrayBuffer();
  } catch (e) {
    return err(`Network error fetching ${url}: ${e instanceof Error ? e.message : String(e)}`);
  }
  try {
    return ok(parseCitizens(buffer));
  } catch (e) {
    return err(e instanceof Error ? e.message : String(e));
  }
}
